import { colors } from '@single-platform/components/dist/design/designVariables';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  gap: 1rem;
  max-width: 540px;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const PageSubtitle = styled.h2`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${() => colors.base.black.shades[60]};
  margin-bottom: 0;
  text-align: center;
`;
